import React from "react";
import { useNavigate } from "react-router-dom";
import { MdWorkspacesOutline } from "react-icons/md";
import { useWorkspaceExperience } from "../../contexts/WorkspaceExperienceContext";

// A persistent way to switch in and out of the Workspace desktop experience, always
// reachable from the header regardless of which page you're on. Styled as an inviting CTA
// while off (encourage trying it) and a plain link once on (it's no longer a pitch, just a
// way back to the classic pages).
function WorkspaceExperienceToggle() {
  const navigate = useNavigate();
  const { workspaceExperienceEnabled, toggleWorkspaceExperience } = useWorkspaceExperience();

  const handleClick = () => {
    const goingTo = workspaceExperienceEnabled ? "/dashboard" : "/workspace";
    toggleWorkspaceExperience();
    navigate(goingTo);
  };

  if (workspaceExperienceEnabled) {
    return (
      <button
        onClick={handleClick}
        className="btn btn-link text-decoration-none"
        style={{ color: "inherit", padding: "0.5rem" }}
        title="Switch back to the classic view"
      >
        <MdWorkspacesOutline size={18} className="me-1 mb-1" />
        Classic view
      </button>
    );
  }

  return (
    <button onClick={handleClick} className="btn btn-outline-primary btn-sm" title="Try the new Workspace experience">
      <MdWorkspacesOutline size={16} className="me-1 mb-1" />
      Try our new experience
    </button>
  );
}

export default WorkspaceExperienceToggle;
